var map = {
	"./1.jpg": "9882",
	"./Antimicrobial Resistance.jpg": "0c6d",
	"./Blog1.png": "5b26",
	"./Blog2.png": "883a",
	"./Blog3.png": "bee9",
	"./Childhood Obesity.jpg": "c28b",
	"./Dispensing Separation.jpg": "5693",
	"./E-cigarettes and Vapes are Not Aids for Smoking Cessation.jpg": "471f",
	"./Erectile Dysfunction in Malaysian Men.jpg": "eeea",
	"./Healthcare Collaboration, Not War Op-Ed.jpg": "5574",
	"./It’s time to talk about sexual health.jpg": "55b8",
	"./Medication Management during Ramadan.jpg": "5a26",
	"./Medication Safety in Pregnancy and Lactation.jpg": "0d4b",
	"./Medication Safety.jpg": "3acc",
	"./Mental Health Illness is Not a Weakness.jpg": "4cb5",
	"./Patient Counselling.jpg": "e835",
	"./Pharmaceutical Compounding.jpg": "4a48",
	"./Pharmacists and the Elderly in Malaysia.jpg": "960a",
	"./Pharmacist’s Role in Immunization.jpg": "c8c0",
	"./Polypharmacy.jpg": "962c",
	"./Public Health.jpg": "85fd",
	"./Shift from Management to Prevention of Diabetes.jpg": "e06e",
	"./Smoking Cessation a Challenge in Malaysia.jpg": "75b4",
	"./Telepharmacy.jpg": "1e4c",
	"./The Role of a Pharmacist in Public Health.jpg": "d447",
	"./The State of Disconnected Care in Malaysia.jpg": "b7d5",
	"./The Utility of E-Prescribing System in Malaysia.jpg": "98ed",
	"./Utilization of Health Information Technology in Malaysia.jpg": "9ee6",
	"./What a Pharmacist Should Know About Pediatric Pharmacy.jpg": "21c3",
	"./Women’s Health.jpg": "47bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d503";